export const PAGE_ROUTE = '/manage/messages';
export const CONVERSATION_ID_PARAM = 'conversationId';

export const CONVERSATIONS_PAGE_LIMIT = 30;
